module.exports = __webpack_public_path__ + "media/images/emblems/Denges-coat_of_arms-784da1f27274d89814de8727b79d2eac.svg";